<a
    class="pill"
    (click)="$event.stopPropagation(); openUploadedDocumentDetailModal()">
    <i class="las la-file-alt"></i>
    <ng-container *ngIf="uploadedDocument; else loading">
        {{ displayName.length > 50 ? (displayName | slice: 0:50) + '...' : displayName }}
    </ng-container>
</a>

<ng-template #loading>
    <app-loading-message></app-loading-message>
</ng-template>
